module.exports = __webpack_public_path__ + "img/red-t2.604206f6.png";